const catalogoProdutosStatusIntegracaoOptions = [
  {
    id: 'PENDENTE',
    value: 'PENDENTE',
  },
  {
    id: 'ERRO',
    value: 'ERRO',
  },
  {
    id: 'ATIVADO',
    value: 'ATIVADO',
  },
  {
    id: 'DESATIVADO',
    value: 'DESATIVADO',
  },
  {
    id: 'RASCUNHO',
    value: 'RASCUNHO',
  },
  {
    id: 'ANALISE_DE_PRODUTO',
    value: 'ANALISE_DE_PRODUTO',
  },
  {
    id: 'INCLUSAO_DE_FABRICANTE',
    value: 'INCLUSAO_DE_FABRICANTE',
  },
  {
    id: 'RASCUNHO_QUICK',
    value: 'RASCUNHO_QUICK',
  },
  {
    id: 'RASCUNHO_OK',
    value: 'RASCUNHO_OK',
  },
  {
    id: 'REALIZADA',
    value: 'REALIZADA',
  },
];

export default catalogoProdutosStatusIntegracaoOptions;
